/**
 * FAQ: theme tabs with a scroll spy, an instant text filter with its counter,
 * and per-question anchors that open the entry they name.
 */
(function () {
  'use strict';
  const bq = window.bq;
  if (!bq) return;

  function init(root) {
    if (!root || root.dataset.bqFaqInit) return;
    root.dataset.bqFaqInit = '1';

    const reduced = bq.reducedMotion();
    const behavior = reduced ? 'auto' : 'smooth';

    if (window.bqReveal) window.bqReveal(root, '[data-faq-reveal]');

    const groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    const items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    const tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rail-target]'));

    tabs.forEach(function (a) {
      a.addEventListener('click', function (e) {
        const target = document.getElementById(a.dataset.railTarget);
        if (!target) return;
        e.preventDefault();
        // Mark active immediately: the scroll spy misses fast jumps.
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === a); });
        target.scrollIntoView({ behavior: behavior, block: 'start' });
        history.replaceState(null, '', '#' + a.dataset.railTarget);
      });
    });

    if ('IntersectionObserver' in window && tabs.length) {
      const spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          tabs.forEach(function (a) {
            a.classList.toggle('is-active', a.dataset.railTarget === en.target.id);
          });
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      groups.forEach(function (gp) { spy.observe(gp); });
    }

    // Opening a question writes its anchor into the address bar; arriving on an
    // anchor opens the entry it names.
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open && item.id) history.replaceState(null, '', '#' + item.id);
      });
    });

    function openFromHash() {
      const hash = window.location.hash;
      if (!hash || hash.indexOf('#q-') !== 0) return;
      const item = document.getElementById(hash.slice(1));
      if (!item || !item.hasAttribute('data-faq-item') || !root.contains(item)) return;
      item.open = true;
      item.scrollIntoView({ behavior: behavior, block: 'start' });
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    const input = root.querySelector('[data-faq-search]');
    const clearBtn = root.querySelector('[data-faq-clear]');
    const countEl = root.querySelector('[data-faq-count]');
    const starters = root.querySelector('[data-faq-starters]');
    const emptyEl = root.querySelector('[data-faq-empty]');
    const resetBtn = root.querySelector('[data-faq-reset]');

    function applyFilter(raw) {
      const q = bq.norm(raw.trim());
      let total = 0;
      groups.forEach(function (gp) {
        let visible = 0;
        gp.querySelectorAll('[data-faq-item]').forEach(function (item) {
          const hit = !q || bq.norm(item.textContent).indexOf(q) !== -1;
          item.hidden = !hit;
          if (hit) visible++;
        });
        gp.hidden = visible === 0;
        total += visible;
        const tab = tabs.filter(function (a) { return a.dataset.railTarget === gp.id; })[0];
        if (tab) tab.parentElement.classList.toggle('is-empty', visible === 0);
      });
      if (countEl) {
        // Both plural forms arrive rendered from the locale, number included:
        // swapping only the number keeps each language's word order.
        const form = total === 1 ? countEl.dataset.countOne : countEl.dataset.countOther;
        countEl.textContent = form.replace(/\d+/, String(total));
      }
      if (emptyEl) emptyEl.hidden = total !== 0;
      if (clearBtn) clearBtn.hidden = !q;
      if (starters) starters.hidden = !!q;
    }

    if (input) {
      let deb;
      input.addEventListener('input', function () {
        clearTimeout(deb);
        deb = setTimeout(function () { applyFilter(input.value); }, 120);
      });

      // Filtering already ran on each keystroke, so this only blurs to close the
      // keyboard; which event the submit key fires depends on the keyboard.
      const done = function () {
        clearTimeout(deb);
        applyFilter(input.value);
        input.blur();
      };
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          done();
        }
      });
      const form = input.form || input.closest('form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          done();
        });
      }
    }

    function resetSearch() {
      if (!input) return;
      input.value = '';
      applyFilter('');
      input.focus();
    }
    if (clearBtn) clearBtn.addEventListener('click', resetSearch);
    if (resetBtn) resetBtn.addEventListener('click', resetSearch);

    bq.wireNuwa(root, '[data-faq-nuwa]');
  }

  document.querySelectorAll('.bq-faq').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-faq').forEach(init);
  });
})();
